export enum LeaderboardType {
  Channel = "channel",
  Community = "community",
  Experience = "experience",
  Global = "global",
}

export enum LeaderboardLength {
  Monthly = "Monthly",
  Weekly = "Weekly",
}
